import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/comprobante-de-estudio';

/**
 * GET Tipos de Seguridad Social
 * @returns {Promise<object[]>}
 */
export const getComprobantesDeEstudios = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Comprobante de estudio
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getComprobanteDeEstudio = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Comprobante de estudio
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postComprobanteDeEstudio = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Comprobante de estudio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchComprobanteDeEstudio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Comprobante de estudio
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteComprobanteDeEstudio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
